export default "__VITE_ASSET__CqbGM5_x__"